import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/csebald/bg_stetoskop_herz-removebg-preview.png";
import WaitingImg from "../../images/hinweise/warten.jpg";

const Hinweise = () => {
    return (
        <main>
            <Header image={Banner} />
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1>Wichtige - Hinweise</h1>

                    <h3>Nichterscheinen ohne Terminabsage – No-Show-Patienten</h3>
                    <p>
                        Sollten Sie einen Termin <b>nicht wahrnehmen</b> können, bitten wir um Verständnis, dass ohne schriftliche Absage bis spätestens 24h vor dem vereinbarten Termin ein pauschaler Aufwandsersatz von € 70,- in Rechnung gestellt wird.
                        <br /><br />
                        Sie können für die Absage auch gerne unsere Kontaktformulare oder Fax verwenden.
                        <br />
                        <a href="/homepage/#/kontakt/terminanfrage">Für allgemeine Anfragen, wie zB: Terminanfragen, Rückrufe, usw</a>
                    </p>

                    <h3>Erstbesuch</h3>
                    <p>
                        Wir bitten Sie, <a onClick={() => {window.open('/pdfs/Patienten_DATENBLATT.pdf', '_blank');}}>dieses Datenblatt</a> bereits ausgefüllt zur Untersuchung mitzubringen:
                        <br />
                        <a onClick={() => {window.open('/pdfs/Patienten_DATENBLATT.pdf', '_blank');}}>
                            http://www.herzdoktor.net/Patienten_DATENBLATT.pdf
                        </a>
                    </p>

                    <h3>Kontakt per Formular</h3>
                    <p>
                        Ein Kontakt per Email ist aus Datenschutzgründen (DSGVO) nicht mehr möglich. Wir haben für die Kontaktaufnahme zwei Formulare vorbereitet:
                        <br />
                        <a href="/homepage/#/kontakt/terminanfrage">Für allgemeine Anfragen</a>
                        <br />
                        <a href="/homepage/#/kontakt/rezeptbestellung">Für die Rezeptbestellung</a>
                    </p>

                    <h3>Wartezeiten</h3>
                    <p>
                        Werte Patientinnen und Patienten, es ist mir ein besonderes Anliegen, die Wartezeiten zu verkürzen. Vereinbaren Sie immer einen Termin (auch wenn Sie nur "kurz" etwas besprechen wollen oder akut ein Problem haben).
                        <br />
                        Ein Anruf genügt, damit wir Bescheid wissen, dass Sie kommen!
                    </p>
                    <p>
                        Aus organisatorischen Gründen öffnet die Ordination 15 Minuten vor Beginn. Wir freuen uns über Pünktlichkeit – ein vorzeitiges Erscheinen verschiebt allerdings <strong>nicht</strong> den Zeitpunkt des eingetragenen Termins.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <img src={WaitingImg} alt="Wartezimmer" style={{ maxWidth: "80%", height: "auto" }} />
                    </div>

                    <h3>Telefonische Auskünfte</h3>
                    <p>
                        Es gibt grundsätzlich <b>keine telefonischen Befundbesprechungen</b>. Jeder Patient soll ungestört mit seiner Ärztin sprechen können.
                    </p>

                    <h3>Medizinische Anfragen per E-Mail</h3>
                    <p>
                        Aufgrund von Datenschutzbestimmungen und begrenzten Zeitressourcen liegt unser Fokus auf der Bearbeitung von Rezepten und Terminanfragen. <b>Wir geben keine Antworten auf medizinische Anfragen per Mail.</b>
                        <br /><br />
                        Für <b>konkrete medizinische Fragen</b> empfehlen wir Ihnen, einen persönlichen Termin zu vereinbaren. Nur so kann Ihre Situation angemessen besprochen werden.
                        <br /><br />
                        Wir danken für Ihr Verständnis und stehen Ihnen gerne für Ihre <b>Terminanfragen und Rezepte</b> zur Verfügung.
                    </p>

                    <h3>Wiener Gebietskrankenkasse (ÖGKK)</h3>
                    <p>
                        Bitte beachten Sie: ÖGKK-Patienten dürfen pro Quartal nur einen Internisten aufsuchen.
                        <br />
                        Falls Sie bereits bei einem anderen Internisten waren, bringen Sie bitte eine Überweisung mit, lassen Sie sich durch die ÖGKK freischalten oder begleichen Sie die Kosten vor Ort (je nach Aufwand).
                    </p>

                    <h3>Vertretungsärzte</h3>
                    <p>
                        In Urlaubs- oder Fortbildungszeiten werde ich von KollegInnen meines Vertrauens vertreten. So profitieren Sie von erweiterten Öffnungszeiten und Zusatzqualifikationen.
                    </p>

                    <h3>Jobs / Bewerbungen</h3>
                    <p>
                        Wir suchen ab Juli 2022 Unterstützung in unserem großartigen Team:
                        <b> Ordinationsassistenz, medizinische Verwaltungsassistenz oder diplomiertes Pflegepersonal mit Vorkenntnissen</b>.
                        <br />
                        <a href="/homepage/#/jobs">Lesen Sie weiter ...</a>
                    </p>
                </div>
            </section>
            <Footer />
        </main>
    );
};

export default Hinweise;
